import { useCreateModalStore, type CreateRequest } from '../../stores/createModalStore';

/** Opens the one Create modal. */
export function useOpenCreate(): (request: CreateRequest) => void {
  return useCreateModalStore((state) => state.open);
}
